// Helper functions
const VALID_APP_DOMAINS = ['imobiliare.ro', 'lendi.pl'] as const;

const resolveAppDomain = (): string => {
  const envDomain = process.env.VUE_APP_APP_DOMAIN;
  if (envDomain && VALID_APP_DOMAINS.includes(envDomain as typeof VALID_APP_DOMAINS[number])) {
    return envDomain;
  }
  return 'lendi.pl';
};

const getEnvironment = (hostname: string[]): string => {
  if (hostname.includes('localhost')) return 'qa';
  if (hostname.includes('127')) return 'qa';
  if (hostname.includes('qa')) return 'qa';
  if (hostname.includes('vercel')) return 'qa';
  if (hostname.includes('demo')) return 'demo';
  return 'production';
};

const setWindowProperty = (key: string, value: any): void => {
  Object.defineProperty(window, key, { value, writable: false });
};

// Main configuration
const hostname = window.location.hostname.split('.');
const appDomain = resolveAppDomain();

// Set environment
setWindowProperty('__ENV__', getEnvironment(hostname));

// Set domain from build/runtime env (e.g. pnpm run serve-dsa / dsa-dev)
setWindowProperty('__DOMAIN__', appDomain);

if (appDomain === 'imobiliare.ro') {
  setWindowProperty('__DOMAIN_CONNECTOR_CHAR__', '-');
  setWindowProperty('__DOMAIN_PREFIX__', 'lendi');
} else {
  setWindowProperty('__DOMAIN_CONNECTOR_CHAR__', '.');
  setWindowProperty('__DOMAIN_PREFIX__', 'platforma');
}

export default {};
